<template>
  <div class="accordion-item">
    <h6 class="accordion-header">
      <button
        class="accordion-button"
        :class="{ collapsed: !expanded }"
        type="button"
        @click="$emit('toggle')"
        :aria-expanded="expanded ? 'true' : 'false'"
        :aria-controls="panelId"
        :id="headerId"
      >
        <!-- Slot for the title/summary row -->
        <slot name="header"></slot>
      </button>
    </h6>
    <div
      :id="panelId"
      class="accordion-collapse"
      :class="{ show: expanded, collapse: !expanded }"
      :aria-labelledby="headerId"
    >
      <div class="accordion-body">
        <!-- Slot for the collapsible content -->
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * CollapsibleItem.vue
 *
 * A reusable accordion/collapsible item for profile sections.
 * Props:
 *   expanded: Boolean - whether the item is expanded
 *   panelId: String - unique id for the collapse panel
 *   headerId: String - unique id for the header
 * Emits:
 *   toggle - when the header is clicked
 *
 * Usage:
 * <CollapsibleItem :expanded="isOpen" :panelId="'panel-1'" :headerId="'header-1'" @toggle="...">
 *   <template #header> ... </template>
 *   ...content...
 * </CollapsibleItem>
 */
export default {
  name: 'CollapsibleItem',
  props: {
    expanded: { type: Boolean, required: true },
    panelId: { type: String, required: true },
    headerId: { type: String, required: true }
  }
}
</script>

<style scoped>
/* No extra styles needed; uses Bootstrap classes */
</style>
